import { SignUpButton } from '@clerk/clerk-react'
import { BrainLogo } from '@/components/ui/brain-logo'

const quickLinks = [
    { label: 'How It Works', href: '#how-it-works' },
    { label: 'Why Join Us', href: '#experts' },
    { label: 'Testimonials', href: '#testimonials' },
]

export function LandingFooter() {
    return (
        <footer className="bg-slate-900 px-4 pb-10 pt-16 text-slate-400 sm:px-6 lg:px-8">
            <div className="mx-auto grid max-w-6xl gap-10 lg:grid-cols-4">
                {/* Brand */}
                <div className="space-y-4 lg:col-span-2">
                    <BrainLogo size="md" />
                    <p className="text-sm text-[#94A3B8] max-w-md">
                        We nurture AI consulting excellence through continuous training and community. Join us in building
                        the future of expert consulting.
                    </p>
                </div>

                {/* Quick Links */}
                <div>
                    <p className="text-xs font-semibold uppercase tracking-[0.3em] text-white">Quick Links</p>
                    <ul className="mt-4 space-y-3">
                        {quickLinks.map((link) => (
                            <li key={link.label}>
                                <a href={link.href} className="text-sm text-[#94A3B8] transition hover:text-white">
                                    {link.label}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>

                {/* Get Started */}
                <div>
                    <p className="text-xs font-semibold uppercase tracking-[0.3em] text-white">Get Started</p>
                    <ul className="mt-4 space-y-3">
                        <li>
                            <SignUpButton mode="modal">
                                <button className="text-sm text-[#94A3B8] transition hover:text-white">
                                    Apply as Expert
                                </button>
                            </SignUpButton>
                        </li>
                        <li>
                            <SignUpButton mode="modal" forceRedirectUrl="/client/dashboard">
                                <button className="text-sm text-[#94A3B8] transition hover:text-white">
                                    Hire AI Experts
                                </button>
                            </SignUpButton>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="mx-auto mt-12 max-w-6xl border-t border-white/10 pt-6 text-center text-xs text-slate-500">
                © {new Date().getFullYear()} AI Expert Network. All rights reserved.
            </div>
        </footer>
    )
}
